export default __webpack_public_path__ + "static/media/port0.3332f582.jfif";